import { Controller } from "@hotwired/stimulus"
import * as React from 'react'
import * as ReactDOM from 'react-dom'
import { EmbedProjectEditor } from '../projects/editor/embed_project_editor'
import { defaultProject, Project } from "../projects/state"
import { DBModels } from "../projects/state/db_models"
import { TeamExtentData } from '../projects/editor/project_editor'
import { readJsonScript } from "../projects/utils/json_script"

export default class extends Controller {
  static values = {
    projectTeamId: Number,
    projectTeamName: String,
    projectDefraHedgerowPermission: Boolean,
    projectKewRgb25cmPermission: Boolean,
    projectKewSamplesPermission: Boolean,
    projectNatmapSoilPermission: Boolean,
    projectKewLidarPermission: Boolean,
    projectPlanetDataPermission: Boolean,
    projectUkEnabled: Boolean,
    projectIndonesiaEnabled: Boolean
  }

  declare readonly projectTeamIdValue: number
  declare readonly projectTeamNameValue: string
  declare readonly projectDefraHedgerowPermissionValue: boolean
  declare readonly projectKewRgb25cmPermissionValue: boolean
  declare readonly projectKewSamplesPermissionValue: boolean
  declare readonly projectNatmapSoilPermissionValue: boolean
  declare readonly projectKewLidarPermissionValue: boolean
  declare readonly projectPlanetDataPermissionValue: boolean
  declare readonly projectUkEnabledValue: boolean
  declare readonly projectIndonesiaEnabledValue: boolean

  connect() {
    const projectSource = readJsonScript<Project>("embed-project-source-json", defaultProject)
    const teamExtents = readJsonScript<TeamExtentData[]>("embed-project-extents-json", [])
    const dbModels = readJsonScript<DBModels>("embed-project-db-models-json", { mapTileLayers: [], overlays: [] })
    const teamComponents = readJsonScript<Array<{ id: number; name: string; component_type: string; settings: Record<string, unknown> }>>(
      "embed-project-team-components-json",
      []
    )

    ReactDOM.render(
      <EmbedProjectEditor
        projectSource={projectSource}
        dbModels={dbModels}
        teamId={this.projectTeamIdValue}
        teamName={this.projectTeamNameValue}
        teamComponents={teamComponents}
        permissions={
          { 
            DefraHedgerows: this.projectDefraHedgerowPermissionValue,
            KewRgb25cm: this.projectKewRgb25cmPermissionValue,
            KewSamples: this.projectKewSamplesPermissionValue,
            NATMAPSoil: this.projectNatmapSoilPermissionValue,
            KewLidar: this.projectKewLidarPermissionValue,
            PlanetData: this.projectPlanetDataPermissionValue,
            isUserGuest: true, // Always guest in embed mode
            ukEnabled: this.projectUkEnabledValue,
            indonesiaEnabled: this.projectIndonesiaEnabledValue
          }
        }
        teamExtents={teamExtents}
      />,
      this.element
    )
  }

  disconnect() {
    ReactDOM.unmountComponentAtNode(this.element)
  }
}
